import React from 'react';
import UploadButton from '../components/UploadButton';

const HomeUpload = props => {
	const { size } = props;
	return (
		<div>
			<UploadButton
				size={size}
				text="Folder"
				directory
			/>
			<UploadButton
				size={size}
				type="primary"
				className="upload-images"
				text="Images"
			/>
		</div>
	);
};

export default HomeUpload;



// WEBPACK FOOTER //
// ./src/components/HomeUpload.js